import { controls,grouped } from "../controls";
const customer_relations = {
label: "Customer Relations",
pageLabel: "Customer Relations",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Title Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "title_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "First Name"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "first_name",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Middle Name"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "middle_name",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Last Name"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "last_name",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Dob",target: "dob"}),
...controls.magicDate({ tab: "filter", name: "dob", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Title",star:false}),
...controls.oc({ tab: "general", c: "Title", placeHolder: "Title Code", name: "title_code", isRequired:false,fastpath:"titles",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "title_display"}),
...controls.displayText({ tab: "general", label: "Gender",star:false}),
...controls.oc({ tab: "general", length:2, c: "Gender", placeHolder: "Gender Code", name: "gender_code", isRequired:false,fastpath:"genders",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "gender_display"}),
...controls.displayText({ tab: "general", label: "First Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "first_name",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Middle Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "middle_name",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Last Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "last_name",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Mothers Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "mothers_name",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fathers Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "fathers_name",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Dob",target: "dob",star:false}),
...controls.magicDate({ tab: "general", name: "dob", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Age"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "age",maxlength:5}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Voterid",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "voterid",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Passport",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "passport",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Ration Card",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "ration_card",isRequired:false,maxlength:14}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Drivers License",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "drivers_license",isRequired:false,maxlength:14}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Marital Status",star:false}),
...controls.oc({ tab: "general", length:2, c: "MaritalStatus", placeHolder: "Marital Status Code", name: "marital_status_code", isRequired:false,fastpath:"marital_statuses",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "marital_status_display"}),
...controls.displayText({ tab: "general", label: "Religion",star:false}),
...controls.oc({ tab: "general", c: "Religion", placeHolder: "Religion Code", name: "religion_code", isRequired:false,fastpath:"religions"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "religion_display"}),
...controls.displayText({ tab: "general", label: "Caste",star:false}),
...controls.oc({ tab: "general", c: "Caste", placeHolder: "Caste Code", name: "caste_code", isRequired:false,fastpath:"castes"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "caste_display"}),
...controls.displayText({ tab: "general", label: "Subcaste",star:false}),
...controls.oc({ tab: "general", c: "SubCaste", placeHolder: "Subcaste Code", name: "subcaste_code", isRequired:false,fastpath:"subcastes"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "subcaste_display"}),
...controls.displayText({ tab: "general", label: "Occupation",star:false}),
...controls.oc({ tab: "general", c: "Occupation", placeHolder: "Occupation Code", name: "occupation_code", isRequired:false,fastpath:"occupations"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "occupation_display"}),
...controls.displayText({ tab: "general", label: "Income Group",star:false}),
...controls.oc({ tab: "general", c: "IncomeGroup", placeHolder: "Income Group Code", name: "income_group_code", isRequired:false,fastpath:"income_groups"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "income_group_display"}),
...controls.displayText({ tab: "general", label: "House Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "house_name",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Village",star:false}),
...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", isRequired:false,fastpath:"villages"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "village_display"}),
...controls.displayText({ tab: "general", label: "Taluka",star:false}),
...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired:false,fastpath:"talukas"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display"}),
]
,history:{
perPage: 10,
reportHeader: "Customer Relations",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Title Id",accessor: "title_id",},
{Header: "First Name",accessor: "first_name",},
{Header: "Middle Name",accessor: "middle_name",},
{Header: "Last Name",accessor: "last_name",},
{Header: "Dob",accessor: "dob",type:'date'},
]}};
export default customer_relations;